module.exports = __webpack_public_path__ + "static/media/catalogo digital_2026_novo.527eaa1d.pdf";